/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuditTrailEventViewModel } from './AuditTrailEventViewModel';
import {
    AuditTrailEventViewModelFromJSON,
    AuditTrailEventViewModelFromJSONTyped,
    AuditTrailEventViewModelToJSON,
} from './AuditTrailEventViewModel';

/**
 * 
 * @export
 * @interface AuditTrailSummaryViewModel
 */
export interface AuditTrailSummaryViewModel {
    /**
     * 
     * @type {number}
     * @memberof AuditTrailSummaryViewModel
     */
    signatoryId: number;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailSummaryViewModel
     */
    signatoryName: string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailSummaryViewModel
     */
    signatorySurname: string;
    /**
     * 
     * @type {Array<AuditTrailEventViewModel>}
     * @memberof AuditTrailSummaryViewModel
     */
    auditEvents: Array<AuditTrailEventViewModel>;
}

/**
 * Check if a given object implements the AuditTrailSummaryViewModel interface.
 */
export function instanceOfAuditTrailSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signatoryId" in value;
    isInstance = isInstance && "signatoryName" in value;
    isInstance = isInstance && "signatorySurname" in value;
    isInstance = isInstance && "auditEvents" in value;

    return isInstance;
}

export function AuditTrailSummaryViewModelFromJSON(json: any): AuditTrailSummaryViewModel {
    return AuditTrailSummaryViewModelFromJSONTyped(json, false);
}

export function AuditTrailSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditTrailSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signatoryId': json['SignatoryId'],
        'signatoryName': json['SignatoryName'],
        'signatorySurname': json['SignatorySurname'],
        'auditEvents': ((json['AuditEvents'] as Array<any>).map(AuditTrailEventViewModelFromJSON)),
    };
}

export function AuditTrailSummaryViewModelToJSON(value?: AuditTrailSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SignatoryId': value.signatoryId,
        'SignatoryName': value.signatoryName,
        'SignatorySurname': value.signatorySurname,
        'AuditEvents': ((value.auditEvents as Array<any>).map(AuditTrailEventViewModelToJSON)),
    };
}

